let printContent = null;

export const setPrintContent = (content) => {
  printContent = content;
};

export const getPrintContent = () => printContent;
